import { render, staticRenderFns } from "./FCopyButton.vue?vue&type=template&id=204c575f&"
import script from "./FCopyButton.vue?vue&type=script&lang=js&"
export * from "./FCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports